module.exports = __webpack_public_path__ + "static/media/organize.bc903294.jpeg";